import React, { useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"
import "components/style.scss"
// import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css"
import NoDataMessage from "components/NoDataMessage"
import Pagination from "components/Pagination"
import { InlineLoadingIndicator } from "components/LoadingIndicator"

export const TableComponent = ({
  keyField = "id",
  columns,
  data,
  withCheckboxes,
  actions,
  onCheckItem,
  onCheckAllItems,
  noTableDataMessage,
  loadingData,
  paginationData,
  onPageChange,
  defaultSorted = [],
  onTableSort,
  hideHeaderClass,
  expandRow,
  rowClasses,
  sort = {},
  search,
  classes,
  headerWrapperClasses,
  noDataIndication,
  cellEdit,
  rowStyle,
  hover = true,
  actionsColumnName = "",
  selectedItems,
  hideSelectAllRows = false,
}) => {
  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect, rowIndex, e) => {
      onCheckItem(row, isSelect, e)
    },
    onSelectAll: (isSelect, rows, e) => {
      onCheckAllItems(rows, isSelect, e)
    },
    selected: selectedItems,
    hideSelectAll: hideSelectAllRows,
  }

  const getColumnsWithActions = () => {
    let columnsWithActions = columns

    if (columnsWithActions?.find(column => column.dataField === "menu"))
      return columnsWithActions

    if (actions && actions.length > 0) {
      columnsWithActions.push({
        dataField: "menu",
        isDummyField: true,
        text: actionsColumnName,
        align: "right",
        headerAlign: (column, colIndex) => "right",
        formatter: (cellContent, user) => (
          <UncontrolledDropdown>
            <DropdownToggle href="#" className="card-drop" tag="i">
              <i className="mdi mdi-dots-vertical font-size-18" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              {actions.map((a, index) => (
                <DropdownItem
                  key={index}
                  href="#"
                  onClick={e => {
                    e.preventDefault()
                    a.onClick(user)
                  }}
                  disabled={a?.isAvailable === false}
                >
                  <i className={a.icon} /> {a.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        ),
      })
    }
    return columnsWithActions
  }
  const [renderColumns, setColumns] = useState(getColumnsWithActions())

  if ((data && data.length > 0) || loadingData) {
    return (
      <Card>
        <CardBody className={"p-0"}>
          <React.Fragment>
            <Row>
              <Col xl="12">
                <div
                // className="table-responsive"
                // style={{ maxWidth: "100%", overflowX: "auto" }}
                >
                  <BootstrapTable
                    keyField={keyField}
                    data={data || []}
                    columns={renderColumns}
                    defaultSorted={defaultSorted}
                    responsive
                    remote={{ sort: !!onTableSort }}
                    onTableChange={onTableSort}
                    bordered={false}
                    striped={false}
                    selectRow={withCheckboxes ? selectRow : undefined}
                    classes={classes || "table align-middle table-hover"}
                    hover={hover}
                    headerClasses={hideHeaderClass}
                    headerWrapperClasses={headerWrapperClasses || "table-light"}
                    noDataIndication={
                      noDataIndication || (
                        <div className={"text-center"}>
                          <InlineLoadingIndicator /> Retrieving data...
                        </div>
                      )
                    }
                    expandRow={expandRow}
                    rowClasses={rowClasses}
                    sort={sort}
                    search={search}
                    cellEdit={cellEdit}
                    rowStyle={rowStyle}
                  />
                </div>
              </Col>
            </Row>
            {paginationData && (
              <Pagination data={paginationData} onPageChange={onPageChange} />
            )}
          </React.Fragment>
        </CardBody>
      </Card>
    )
  } else {
    return <NoDataMessage content={noTableDataMessage} />
  }
}
export default TableComponent
